const file = '/Files/';

export default {
    login: {
        userLogin: '/user/Login', // POST 用户登录
        userInfo: '/user/UserInfo', // POST 用户信息
    },
    file: {
        filesBaseInfo: file + 'FilesBaseInfo',
        mergeFiles: file + 'MergeFiles',
        uploadFiles: file + '/UploadFiles',
        getFilesTaskList: file + 'GetFilesTaskList',
        stopUploadFiles: file + 'StopUploadFiles',
        deleteChunkFiles: file + 'DeleteChunkFiles',
        delFolderOrFile: file + 'DeleteFolderOrFile',
        uploadScreenshot: '/Model/UploadScreenshot'
    },
    home: {
        getImageList: '/Model/GetOneImage', // POST 获取图片列表
        getImage: '/Model/GetImage', // GET 获取图片流
        slideImage: '/Model/SlideImage/', // POST 获取图片缩放层碎片
    },
    dict: {
        listData: '/Dict/ListData',
    },
    modal: {
        getTaskLoad: '/Model/GetTaskLoad',
        getServerMonitor: '/Model/GetServerMonitor',
        createDataSet: '/Model/CreateDataSet',
        deleteDataSet: '/Model/DeleteDataSet',
        getDataSetList: '/Model/GetDataSetList',
        setupDataSetStatus: '/Model/SetupDataSetStatus',
        createModel: '/Model/CreateModel',
        getModelList: '/Model/GetModelList',
        getModelNameList: '/Model/GetModelNameList',
        setupModelStatus: '/Model/SetupModelStatus',
        setupModelDefault: '/Model/SetupModelDefault',
        deleteModel: '/Model/DeleteModel',
        specificTaskList: '/Model/SpecificTaskList',
        getModelStructureList: '/Model/GetModelStructureList',
        getDataSetNameList: '/Model/GetDataSetNameList',
        createModelTrain: '/Model/CreateModelTrain',
        getModelTrainNameList: '/Model/GetModelTrainNameList',
        getResourceUsage: '/Model/GetResourceUsage',
        getTrainOutput: '/Model/GetTrainOutput',
        getTensorboard: '/Model/GetTensorboard',
        getTrainDetails: '/Model/GetTrainDetails',
        getTrainThumbnail: '/Model/GetTrainThumbnail',
        getImagesList: '/Model/GetImagesList',
        getIllationPresetResult: '/Model/GetIllationPresetResult',
        downloadLayerFile: '/Model/DownloadLayerFile',
        deleteImages: '/Model/DeleteImages',
        filePreviewHandler: '/Model/FilePreviewHandler',
        layerBindImage: '/Model/LayerBindImage',
        deleteLayer: '/Model/DeleteLayer',
        addLayer: '/Model/AddLayer',
        orderByLayer: '/Model/OrderByLayer',
        startIllationPreset: '/Model/StartIllationPreset',
        getIllationPresetList: '/Model/GetIllationPresetList',
        deleteIllationPreset: '/Model/DeleteIllationPreset',
        getConversationsList: '/Model/GetConversationsList',
        clearConversations: '/Model/ClearConversations',
        conversations: '/Api/Model/Conversations',
        getIllationPresetLog: 'Model/GetIllationPresetLog',
        getModelTrainList: '/Model/GetModelTrainList',
        deleteModelTrain: '/Model/DeleteModelTrain',
    },
    system: {
        listSysMsg: '/System/ListSysMsg'
    }
}